var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Page',{attrs:{"title":"Daftar Kegiatan"}},[_c('div',{staticStyle:{"padding":"20px","background":"white"}},[_c('div',{staticStyle:{"display":"flex"}},[_c('Select',{attrs:{"dbref":"MST.SelBalai","width":"500px","value":_vm.BalaiID},on:{"update:value":function($event){_vm.BalaiID=$event}}}),_c('v-spacer'),_c('v-btn',{attrs:{"small":"","color":"primary"}},[_vm._v("IMPORT DATA KEGIATAN")])],1),_c('Grid',{attrs:{"datagrid":_vm.datagrid,"dbref":"MST.DaftarKegiatan","dbparams":_vm.params,"height":"calc(100vh - 190px)","columns":[
        {
          name: 'Kode',
          value: 'KodeKegiatan',
          editable: {
            com: 'Input',
          },
        },
        {
          name: 'Kegiatan',
          value: 'NamaKegiatan',
          editable: {
            com: 'Input',
          },
        } ]},on:{"update:datagrid":function($event){_vm.datagrid=$event},"update:dbparams":function($event){_vm.params=$event}},scopedSlots:_vm._u([{key:"row-NamaKegiatan",fn:function(ref){
      var row = ref.row;
return [_c('div',{class:row.ClassName},[_vm._v(_vm._s(row.NamaKegiatan))])]}}])})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }